import { Box, Card, Divider, Stack, Typography, styled } from "@mui/material"
import type { CommitteeMember } from "../useCommitteePlatform"
import { CPMemberCardActions } from "./CPMemberCardActions"
import { CPStatusChip } from "./CPStatusChip"

export const CPMemberCard = ({
  user: { firstName, lastName, email, id, role },
  isActive,
  isActivatable,
  isCurrentUser,
}: CommitteeMember) => {
  const userFullName = `${firstName} ${lastName.toUpperCase()}`
  const initials = `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`

  return (
    <Card sx={(theme) => ({ padding: theme.spacing(2) })}>
      <Box display="grid" gridTemplateColumns="30% max-content 1fr" gap={4}>
        <Stack direction="row" gap={2}>
          <InitialContainer>{initials}</InitialContainer>
          <Stack justifyContent="space-around" overflow="hidden">
            <Typography variant="14px" fontWeight={600} noWrap>
              {userFullName}
            </Typography>
            <Typography variant="12px" noWrap>
              {email}
            </Typography>
          </Stack>
        </Stack>
        <Divider flexItem orientation="vertical" />
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          <CPMemberCardActions
            isActive={isActive}
            isActivatable={isActivatable}
            userFullName={userFullName}
            userId={id}
            userEmail={email}
            isCurrentUser={isCurrentUser}
            canUpdate={role !== "ADHERENT_HOLDER" || isCurrentUser}
          />
          <CPStatusChip isActive={isActive} />
        </Stack>
      </Box>
    </Card>
  )
}

const InitialContainer = styled(Box)(({ theme }) => ({
  height: 50,
  width: 50,
  borderRadius: 50,
  backgroundColor: theme.palette.grey.extraLight,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
}))
